import {
  type RouteObject,
  RouterProvider,
  createBrowserRouter
} from 'react-router-dom';

import { basePath } from './basePath';
import { ThemeProvider } from './ThemeProvider';
import { UserProvider } from './hooks/useUser';
import { useCustomAntdTheme } from './useCustomAntdTheme';
import { default as ConfigProvider } from 'antd/es/config-provider';

export interface AppProps {
  routes: Array<RouteObject>;
}

export function App(props: AppProps) {
  const router = createBrowserRouter(props.routes, {
    basename: `/${basePath}`
  });

  return (
    <ThemeProvider>
      <ThemeWrapper>
        <UserProvider>
          <RouterProvider router={router} />
        </UserProvider>
      </ThemeWrapper>
    </ThemeProvider>
  );
}

function ThemeWrapper({ children }: { children: JSX.Element }) {
  const customTheme = useCustomAntdTheme();

  return <ConfigProvider theme={customTheme}>{children}</ConfigProvider>;
}
